import { Rel } from '../Resource/Types';
import Links from './Init';

export const { findLinkBy, findLinkByR, findLinkByT, declareEndpoint } = Links;

export interface MissingLinkError {
  kind: 'missing-link-error';
  rel: Rel;
}
